class ContactApi {

    constructor(seamApi) {
        this.api = seamApi;
    }

    async message(params = {}, validationCallback) {
        return  await this.api.post('/contacts/message', params, validationCallback);
    }

}


export default ContactApi;
